import { Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Permissions } from '../../../../../shared/auth/constants/permissions';
import { useHasPermission, usePermissions } from '../../../../Session';
import { FullSaleTransactionDataFragment } from '../../../../api';
import Accordion from '../../../../components/Accordion';
import useCommonStyles from '../../../../useCommonStyles';
import useBiddingSetting from '../../../../utilities/useBiddingSetting';
import ViewBiddingEntry from './ViewBiddingEntry';

export type TopBidsProps = {
    saleTransaction: FullSaleTransactionDataFragment;
    useCardDesignForAccordion?: boolean;
    title?: string;
};

const TopBids = ({ saleTransaction, useCardDesignForAccordion, title }: TopBidsProps) => {
    const { t } = useTranslation(['saleTransactionsPage']);
    const permissions = usePermissions();
    const canViewTopBids = useHasPermission(Permissions.OFFER_VIEW_TOP_BIDS);
    const { biddingSetting } = useBiddingSetting();

    const commonStyles = useCommonStyles();

    const usedTitle =
        title ?? t('saleTransactionsPage:sessionDetails.topBids.title', { topDealCount: biddingSetting.topDealCount });

    const entries = saleTransaction.latestBiddingSessionEntry?.topBiddingEntries ?? [];

    if (!canViewTopBids) {
        // user cannot see biddings
        return null;
    }

    return (
        <Grid xs={12} item>
            <Accordion title={usedTitle} useCardDesign={useCardDesignForAccordion} defaultExpanded>
                <div style={{ width: '100%' }}>
                    {entries?.map((entry, index) => (
                        <ViewBiddingEntry key={entry.id} entry={entry} index={index} permissions={permissions} />
                    ))}

                    {!entries?.length && (
                        <Typography className={commonStyles.fontWeightLight}>
                            {t('saleTransactionsPage:sessionDetails.topBids.noBids')}
                        </Typography>
                    )}
                </div>
            </Accordion>
        </Grid>
    );
};

export default TopBids;
